<template>
  <div class="batch-card-packaging-icon">
    <div
      :id="'batch-card-packaging-' + index"
      class="batch-card-packaging-icon__regular"
    >
      <svg-loader
        :src="'/static/images/icon-' + packagingState + '.svg'"
        :class="packagingColor"
      />
      <md-tooltip
        md-delay="100"
        md-direction="bottom"
      >
        {{ packagingName }}
      </md-tooltip>
    </div>
  </div>
</template>


<script>
import strings from '@/strings'

export default {
  name: 'BatchCardPackagingIcon',
  props: {
    packagingId: {
      type: Number
    },
    index: {
      type: Number,
      default: 0
    }
  },
  computed: {
    packagingState: function () {
      return strings.packagingStatus.find(x => x.id === this.packagingId).state
    },
    packagingName: function () {
      return strings.packagingStatus.find(x => x.id === this.packagingId).name
    },
    packagingColor: function () {
      return strings.packagingStatus.find(x => x.id === this.packagingId).color
    }
  }
}
</script>

<style lang="scss" scoped>
.batch-card-packaging-icon {
  flex: 20%;

  &__regular {
    width: 30px;
    height: 30px;
    cursor: help;
    position: relative;
    float: right;

    .md-icon {
      border-radius: 10%;
      padding: 4px;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
